var _rect, _circle, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#FCE5D8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.0006,
    cy: 32,
    r: 22.4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8003 19.2C45.8003 18.8687 46.0689 18.6 46.4003 18.6L52.0003 18.6C52.3317 18.6 52.6003 18.8687 52.6003 19.2C52.6003 19.5314 52.3317 19.8 52.0003 19.8L46.4003 19.8C46.0689 19.8 45.8003 19.5314 45.8003 19.2Z",
    fill: "#F7BA97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00049 39.2C7.00049 38.8687 7.26912 38.6 7.60049 38.6L13.2005 38.6C13.5319 38.6 13.8005 38.8687 13.8005 39.2C13.8005 39.5314 13.5319 39.8 13.2005 39.8L7.60049 39.8C7.26912 39.8 7.00049 39.5314 7.00049 39.2Z",
    fill: "#F7BA97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2002 22C48.2002 21.6687 48.4688 21.4 48.8002 21.4L51.2002 21.4C51.5316 21.4 51.8002 21.6687 51.8002 22C51.8002 22.3314 51.5316 22.6 51.2002 22.6L48.8002 22.6C48.4688 22.6 48.2002 22.3314 48.2002 22Z",
    fill: "#F7BA97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40039 42C9.40039 41.6687 9.66902 41.4 10.0004 41.4L12.4004 41.4C12.7318 41.4 13.0004 41.6687 13.0004 42C13.0004 42.3314 12.7318 42.6 12.4004 42.6L10.0004 42.6C9.66902 42.6 9.40039 42.3314 9.40039 42Z",
    fill: "#F7BA97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2002 19.2C54.2002 18.8687 54.4688 18.6 54.8002 18.6H56.4002C56.7316 18.6 57.0002 18.8687 57.0002 19.2C57.0002 19.5314 56.7316 19.8 56.4002 19.8H54.8002C54.4688 19.8 54.2002 19.5314 54.2002 19.2Z",
    fill: "#F7BA97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0507 20.3442C20.2441 20.2056 20.5011 20.1943 20.7059 20.3155L44.0666 34.1417C45.1971 34.8108 45.0023 36.5024 43.7493 36.8971L37.5096 38.8626L36.4033 43.2287C36.3559 43.4158 36.2214 43.5687 36.0418 43.6395C35.8622 43.7103 35.6595 43.6904 35.4971 43.5859L32.4104 41.6003L26.7519 44.5484C25.8602 45.013 24.7713 44.4985 24.5641 43.5146L19.8132 20.9555C19.7641 20.7227 19.8573 20.4828 20.0507 20.3442ZM33.6359 40.9617L34.5975 41.5804L34.2369 40.6486L33.6359 40.9617ZM33.652 39.6003L26.1974 43.4842C26.0103 43.5817 25.7818 43.4737 25.7384 43.2673L21.5491 23.3754L33.652 39.6003ZM27.0211 28.7041L35.0354 39.4479C35.0679 39.4915 35.0944 39.5393 35.114 39.5901L35.7022 41.1101L36.3475 38.5634L27.0211 28.7041ZM37.1881 37.7058L43.3888 35.7525C43.6517 35.6697 43.6926 35.3148 43.4554 35.1744L23.7753 23.5266L37.1881 37.7058Z",
    fill: "#E9688A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.a04f9c96f36d7f9813c11b53509bf463.svg";
export { ForwardRef as ReactComponent };